import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { System } from '@app/core/resources/system';
import { environment } from 'environments/environment.base';
import { DocumentCollection } from 'ngx-jsonapi';

export interface IHelpCard {
    alt: string;
    title: string;
    imageUrl: string;
    titleCard: string;
    linkCard: string;
}

@Component({
    selector: 'app-systems-recommendations',
    templateUrl: './systems-recommendations.component.html',
    styleUrls: ['./systems-recommendations.component.scss']
})
export class SystemsRecommendationsComponent implements OnChanges {
    @Input() public system1: System = new System();
    @Input() public system2: System = new System();
    @Input() public systems: DocumentCollection<System> = new DocumentCollection();

    public cardsSend: Array<IHelpCard> = [];
    public cardsReceive: Array<IHelpCard> = [];

    public constructor(private changeDetectorRef: ChangeDetectorRef) {}

    public ngOnChanges(): void {
        this.cardsSend = [];
        this.cardsReceive = [];

        this.generateCards('can_send', this.system1, this.system2, this.cardsSend);
        this.generateCards('can_receive', this.system2, this.system1, this.cardsReceive);
        this.changeDetectorRef.detectChanges();
    }

    private generateCards(
        type: 'can_send' | 'can_receive',
        sourceSystem: System,
        targetSystem: System,
        targetCards: Array<IHelpCard>
    ): void {
        const isReceiveCard: boolean = type === 'can_receive';
        sourceSystem.relationships.rates.data
            .filter(
                (rate) =>
                    this.getSystemsIds(type).includes(rate.attributes.system_id) &&
                    rate.attributes.system_id !== sourceSystem.id &&
                    rate.attributes.system_id !== targetSystem.id
            )
            .forEach((rate): void => {
                let targetSystemInstance: System | null = this.systems.find(rate.attributes.system_id);
                if (targetSystemInstance === null) {
                    return;
                }

                let sourceId: string = sourceSystem.id;
                let targetId: string = targetSystemInstance.id;

                if (isReceiveCard) {
                    [sourceId, targetId] = [targetId, sourceId];
                }

                let imageUrl: string = environment.LEGACYURL + 'og/' + sourceId + '-' + targetId + '.png';
                let titleCard: string =
                    'Pasar ' +
                    (isReceiveCard ? targetSystemInstance.attributes.alternative_name : sourceSystem.attributes.alternative_name) +
                    ' a ' +
                    (isReceiveCard ? sourceSystem.attributes.alternative_name : targetSystemInstance.attributes.alternative_name);

                let linkCard: string =
                    '/cobrar/' +
                    (isReceiveCard ? targetSystemInstance.id : sourceSystem.id) +
                    '-a-' +
                    (isReceiveCard ? sourceSystem.id : targetSystemInstance.id);
                targetCards.push({
                    alt: titleCard,
                    title: titleCard,
                    imageUrl: imageUrl,
                    titleCard: titleCard,
                    linkCard: linkCard
                });
            });
    }

    private getSystemsIds(type: 'can_send' | 'can_receive'): Array<string> {
        return this.systems.data.filter((system: System) => system.attributes[type]).map((system: System) => system.id);
    }
}
